import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { useBundledProductPurchaseMotions } from '../../../../features/purchaseMotions/hooks/useBundledProductPurchaseMotions';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { useShouldShowTermToggleForMerchCard } from '../../../../hooks/useShouldShowTermSelectorForMerchCard';
import { useAppSelector } from '../../../../reducers';
import { getIsTBSkuSelector, productSelector } from '../../../../selectors/ProductsSelectors';
import { productLineToSkuCategoryName } from '../../../../v2/constants';
import { useHasHigherProductLevelInProductInventory } from '../../../../v2/hooks/inventory/useHighestProductLevel';
import { isValidProductLevel, isValidProductLine } from '../../../../v2/utils/typeguards';
export const useProductCardMetadata = ({
  apiName
}) => {
  const isAppReady = useGlobalLoading();
  const product = useAppSelector(state => {
    if (!isAppReady) return null;
    return productSelector(state, {
      apiName
    });
  });
  const skuId = product === null || product === void 0 ? void 0 : product.currentSkuId;
  const productLevel = isValidProductLevel(product === null || product === void 0 ? void 0 : product.productLevel) ? product === null || product === void 0 ? void 0 : product.productLevel : undefined;
  const productLine = isValidProductLine(product === null || product === void 0 ? void 0 : product.productLine) ? product === null || product === void 0 ? void 0 : product.productLine : undefined;
  const shouldShowTermSelector = useShouldShowTermToggleForMerchCard(product);

  // CTAs Metadata
  const purchaseMotions = useBundledProductPurchaseMotions({
    skuId
  });
  const productSkuCategoryName = productLine ? productLineToSkuCategoryName[productLine] : undefined;
  const {
    hasHigherProductLevel: hasHigherTieredProduct
  } = useHasHigherProductLevelInProductInventory({
    productLevel,
    skuCategoryName: productSkuCategoryName
  });
  const isHubspotFree = apiName === FreeProducts.HUBSPOT_FREE;

  // Features Metadata
  const isSuiteProduct = useAppSelector(state => isAppReady && skuId ? getIsTBSkuSelector(state, {
    skuId
  }) : false);
  const shouldShowSuiteObjectives = (isHubspotFree || isSuiteProduct) && productLevel;
  return {
    skuId,
    productLevel,
    productLine,
    shouldShowTermSelector,
    purchaseMotions,
    hasHigherTieredProduct,
    isHubspotFree,
    shouldShowSuiteObjectives
  };
};